import {AppUser} from "models/app";
import {ProprietarioObject} from "models/Proprietario";
import React, {useEffect, useState} from "react";
import {useForm} from "lib/formHook";
import {filterProprietariosByNome, MAX_RESULTS} from "./controller";
import {ModalBodyPart, ModalContent, ModalFooter} from "components/Modal";
import Input from "components/forms/Input";
import {IonButton} from "@ionic/react";
import {FormDefinition} from "lib/forms";
import {MIN_NOME_LENGTH} from "./Busca";
import BuscaResultados from "./BuscaResultados";
import {FazendaIndexProprietario} from "../../../lib/DataHooks/fazendas";

interface BuscaNoneProps {
  user: AppUser;
  proprietarios: ProprietarioObject[];
  onSelect?: (prop: ProprietarioObject) => void;
  onNotfound: (nome: string) => void;
  initialNome?: string;
  indexProprietarios?: FazendaIndexProprietario;
  onClickBack?: () => void;
}

const formBuscaNome: FormDefinition = {
  nome: {name: 'nome', label: 'Nome do proprietário', type: "string", required: false},
};

const BuscaNome: React.FC<BuscaNoneProps> = (props) => {
  const {proprietarios, user, onSelect, onNotfound,
    initialNome, indexProprietarios, onClickBack} = props;
  const [filtered, setFiltered] = useState(false);
  const [found, setFound] = useState<ProprietarioObject[]>([]);
  const [total, setTotal] = useState(0);
  const {formState, setFieldValue} = useForm(formBuscaNome, {nome: initialNome});
  const defaultMessage = 'Verifique se o proprietário já está cadastrado, digite o nome completo para prosseguir.';
  const [message, setMessage] = useState(defaultMessage);
  const [showResults, setShowResults] = useState(false);
  const nome = formState.nome.value;

  useEffect(() => {
    if (nome) {
      // console.log('CHANGED NOME', nome);
      setFiltered(false);
    }
  }, [nome]);

  useEffect(() => {
    if (nome && !filtered) {
      if (nome.length < MIN_NOME_LENGTH) {
        setMessage('Informe ao menos 3 caracteres para que possamos realizar a busca.');
        setShowResults(false);
        return;
      }

      // console.log('searchNome', nome);
      const {found, total} = filterProprietariosByNome(proprietarios, nome);
        setFound(found);
        setTotal(total);
        setFiltered(true);
    }
  }, [filtered, nome, proprietarios]);

  useEffect(() => {
    if (!nome) {
      // console.log('resetNome');
      setMessage(defaultMessage);
      if (filtered)
        setFiltered(false);
    }
  }, [nome, filtered]);

  useEffect(() => {
    if (filtered) {
      if (total === 0)
        setMessage('Confirme os dados inseridos ou clique abaixo em Cadastrar novo para inserir prosseguir.');
      else if (total > MAX_RESULTS)
        setMessage(`Mais de ${MAX_RESULTS} proprietários encontrados, continue preenchendo o nome para refinar a busca.`);
      else if (total > 0 && !onSelect)
        setMessage('Verifique os resultados apresentados.');
      else
        setMessage('Selecione um dos proprietários encontrados ou clique em Cadastrar novo.');
      setShowResults(true);
    }
  }, [found, filtered, total, onSelect]);

  return (
    <ModalBodyPart>
      <ModalContent>
        <div className="app-form-step-title">
          1. Cadastro do proprietário
        </div>

        <div className="text-sm opacity-75">
          Precisamos verificar primeiramente se proprietário já está cadastrado.
        </div>

        <div>
          <Input
            definition={formBuscaNome.nome}
            onChange={setFieldValue}
            state={formState.nome}
          />
        </div>

        {filtered && showResults &&
          <div className="mt-8 flex-grow">
            <BuscaResultados
              user={user}
              found={found}
              total={total}
              onSelect={onSelect}
              indexProprietarios={indexProprietarios}
            />
          </div>
        }
      </ModalContent>

      <ModalFooter
        message={message}
      >
        <div className="flex items-center gap-4 justify-between">
          {onClickBack &&
            <IonButton
              color="light"
              onClick={onClickBack}
            >
              Voltar
            </IonButton>
          }
          {filtered &&
            <IonButton
              onClick={() => onNotfound(nome)}
            >
              Cadastrar novo
            </IonButton>
          }
        </div>
      </ModalFooter>
    </ModalBodyPart>
  );
}

export default BuscaNome;